// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.new_User_heading {
    font-size: 22px;
    font-weight: 700;
    text-align: center;
  }
  
  .CreateNewUser_employeid {
    display: flex;
    gap: 25px;
    padding-top: 8px;
  }
  
  .DisplayDetailsOfUser {
    position: relative;
    /* border: 1px solid rgb(200, 200, 200); */
    height: 428px;
    /* height: 611px; */
    display: flex;
    flex-direction: column;
    gap: 15px;
    /* background: #fff; */
    padding: 5px;
    border-radius: 8px;
    /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); */
    width: 100%; /* Ensure each child takes the full available width */
    box-sizing: border-box; /* Ensures padding is included in width calculation */
  }
  .edit-user-detail {
    margin-top: -31px;
  }
  .newUser_save_btn {
    padding: 12px 17px;
    border-radius: 5px;
    position: relative;
    display: flex;
    left: 88%;
    top: -59px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
    color: #555;
  }
  /* .navigation-buttons {
   
    position: absolute;
    bottom: 0;
    margin-left: 30%;
  
  
    width: 68%;
   
    display: flex;
    justify-content: center;
    gap: 350px;
    margin-bottom: 5px;
  } */
  
  `, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/ProfileComponent/CreateNewUser.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW,EAAE,qDAAqD;IAClE,sBAAsB,EAAE,qDAAqD;EAC/E;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,UAAU;IACV,sCAAsC;IACtC,WAAW;EACb;EACA;;;;;;;;;;;;;KAaG","sourcesContent":["\n\n.new_User_heading {\n    font-size: 22px;\n    font-weight: 700;\n    text-align: center;\n  }\n  \n  .CreateNewUser_employeid {\n    display: flex;\n    gap: 25px;\n    padding-top: 8px;\n  }\n  \n  .DisplayDetailsOfUser {\n    position: relative;\n    /* border: 1px solid rgb(200, 200, 200); */\n    height: 428px;\n    /* height: 611px; */\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    /* background: #fff; */\n    padding: 5px;\n    border-radius: 8px;\n    /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); */\n    width: 100%; /* Ensure each child takes the full available width */\n    box-sizing: border-box; /* Ensures padding is included in width calculation */\n  }\n  .edit-user-detail {\n    margin-top: -31px;\n  }\n  .newUser_save_btn {\n    padding: 12px 17px;\n    border-radius: 5px;\n    position: relative;\n    display: flex;\n    left: 88%;\n    top: -59px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n    color: #555;\n  }\n  /* .navigation-buttons {\n   \n    position: absolute;\n    bottom: 0;\n    margin-left: 30%;\n  \n  \n    width: 68%;\n   \n    display: flex;\n    justify-content: center;\n    gap: 350px;\n    margin-bottom: 5px;\n  } */\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
